import _defineProperty from "/data/git/test-airspace/nginx-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import axios from 'axios';
import router from '../router';
// const baseURL = 'http://doc.geoai.com:11300'; // Yapi mock 地址
// const baseURL = 'http://192.168.106.40:9527'; // miao
const baseURL = 'http://122.9.126.216/gateway'; // dev
const GATEWAY = {
  ASP: '/geoai-asp-service',
  AUTH: '/geoai-auth-service',
  FILE: '/geoai-file-service'
};
// 创建自定义配置的axios实例
class Request {
  constructor() {
    _defineProperty(this, "instance", void 0);
    this.instance = axios.create({
      baseURL: process.env.NODE_ENV === 'production' ? window._aspConfig.baseURL : baseURL,
      timeout: 100000,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    });
    // 请求拦截器
    this.instance.interceptors.request.use(config => {
      // 添加token等请求头
      if (sessionStorage.getItem('token') && config.headers.Authorization === undefined) {
        config.headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;
      }
      config.headers['Accept-Language'] = `zh-CN`;
      return config;
    }, error => {
      return Promise.reject(error);
    });
    // 响应拦截器
    this.instance.interceptors.response.use(response => {
      // 在这里处理响应数据
      const {
        data
      } = response;
      if (data.code === '00000') {
        return data.data; // 直接返回业务数据
      } else if (data.code == '00003') {
        ElMessage.error('Token已过期，请重新登录');
        router.replace({
          path: '/login'
        });
      } else {
        ElMessage.error(data.msg);
        // 处理业务错误
        return Promise.reject(new Error(data.message || '请求失败'));
      }
    }, error => {
      // 处理HTTP错误
      if (error.response) {
        switch (error.response.status) {
          case 401:
            // 处理未授权
            break;
          case 403:
            // 处理禁止访问
            break;
          case 404:
            // 处理资源不存在
            break;
          case 500:
            // 处理服务器错误
            break;
          default:
            break;
        }
      }
      return Promise.reject(error);
    });
  }
  // 封装请求方法
  get(url, config) {
    return this.instance.get(url, config);
  }
  post(url, data, config) {
    return this.instance.post(url, data, config);
  }
}
// 导出单例
const http = new Request();
export { GATEWAY, http };